<template>
    <transition appear name="alert">
        <div v-show="show"
             :style="{ background }"
             :class="['base-alert', { 'base-alert-close': closable}]">
            <div v-if="closable" class="close-alert" @click="clear()">
              <icon class="close-icon" 
                    name="close-x" 
                    width="18px" 
                    height="18px" 
                    fill="var(--lighten-7-color)"/>
            </div>
            <slot></slot>
        </div>
    </transition>
</template>

<script>

    export default {
        name: "base-alert",
        props: {
          background: {
            type: String,
            default: "var(--white-color)"
          },
          closable: {
            type: Boolean,
            default: false
          }
        },
        computed: {
            show() {
                return this.$store.getters['getAlertShow'];
            }
        },
        methods: {
            clear() {
                this.$emit("close");
            }
        }
    }
</script>

<style scoped>
    .base-alert {
        position: fixed;
        top: 20px;
        right: 0;
        transform: translateX(0);
        background-color: var(--white-color);
        box-shadow: 0 5px 15px rgba(0, 0, 0, .5);
        padding: 14px 20px;
        z-index: 1000;
        transition: all .6s
    }
    .base-alert-close{
        padding: 22.5px 20px 14px 20px;
    }
    .alert-enter-active, .alert-leave-active {
        transition: opacity .5s;
    }
    .alert-enter-to {
        transform: translateX(100%);
    }
    .alert-enter, .alert-leave-to {
        opacity: 0;
    }
    .close-alert {
        display: flex;
        justify-content: end;
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
    }
</style>
